var map = {
	"./404-image.svg": 399,
	"./404.png": 1934,
	"./404.svg": 1935,
	"./504.png": 400,
	"./AboutUs/10.png": 1289,
	"./AboutUs/AboutUs.png": 1693,
	"./AboutUs/CDN.svg": 1694,
	"./AboutUs/Colocation.svg": 1695,
	"./AboutUs/about-header.svg": 1696,
	"./AboutUs/analytics.svg": 1697,
	"./AboutUs/budget.svg": 1698,
	"./AboutUs/consulting.svg": 1699,
	"./AboutUs/container.svg": 1700,
	"./AboutUs/contract.svg": 1701,
	"./AboutUs/cost.svg": 1702,
	"./AboutUs/demo.svg": 1703,
	"./AboutUs/header.svg": 1704,
	"./AboutUs/history.png": 1705,
	"./AboutUs/license.svg": 1706,
	"./AboutUs/mission.png": 1707,
	"./AboutUs/missionicon.png": 1708,
	"./AboutUs/pop.svg": 1709,
	"./AboutUs/sazman.svg": 1710,
	"./AboutUs/security.svg": 1711,
	"./AboutUs/uptime.svg": 1712,
	"./ContactUs/1.png": 1726,
	"./ContactUs/2.png": 1727,
	"./ContactUs/3.png": 1728,
	"./ContactUs/4.png": 1729,
	"./ContactUs/5.png": 1730,
	"./ContactUs/Blog.svg": 1731,
	"./ContactUs/Blog.webp": 1732,
	"./ContactUs/ContactUs.png": 1733,
	"./ContactUs/ContactUsicon.png": 1734,
	"./ContactUs/Help.webp": 1735,
	"./ContactUs/Location.svg": 1736,
	"./ContactUs/Question.svg": 1737,
	"./ContactUs/Search.webp": 1738,
	"./ContactUs/Video.svg": 1739,
	"./ContactUs/facebook.svg": 1740,
	"./ContactUs/header.svg": 1574,
	"./ContactUs/instagram.svg": 1741,
	"./ContactUs/linkedin.svg": 1742,
	"./ContactUs/mail.svg": 1575,
	"./ContactUs/map-m.svg": 1743,
	"./ContactUs/map.svg": 1744,
	"./ContactUs/person.svg": 1576,
	"./ContactUs/phone.svg": 1430,
	"./ContactUs/pointer.svg": 1577,
	"./ContactUs/support.svg": 1578,
	"./ContactUs/telegram.svg": 1745,
	"./ContactUs/ticket.svg": 1579,
	"./ContactUs/twitter.svg": 1746,
	"./ContactUs/youtube.svg": 1747,
	"./MainSlider-ld/1.png": 1936,
	"./MainSlider-ld/2.png": 1937,
	"./MainSlider-ld/3.png": 1938,
	"./MainSlider-ld/4.png": 1939,
	"./MainSlider-ld/Main.png": 1940,
	"./MainSlider/1.png": 1941,
	"./MainSlider/2.png": 1942,
	"./MainSlider/3.png": 1943,
	"./MainSlider/4.png": 1944,
	"./MainSlider/Cloud-migration.jpg": 1945,
	"./MainSlider/Cloud-migration.webp": 1748,
	"./MainSlider/Main.png": 1946,
	"./MainSlider/Slider.png": 1947,
	"./MainSlider/XaaSSliderPlaformKubernetes.svg": 1948,
	"./MainSlider/XaaSSliderPlaformKubernetes1.svg": 1949,
	"./MainSlider/x-background.svg": 1950,
	"./MainSlider/xaas-logo.svg": 1951,
	"./ManagedService/Adobe.svg": 1162,
	"./ManagedService/Atlassia.svg": 1163,
	"./ManagedService/Big.svg": 1164,
	"./ManagedService/Bugzilla.svg": 1165,
	"./ManagedService/Cpanel.svg": 1166,
	"./ManagedService/Customers/Etebar-gary.png": 1094,
	"./ManagedService/Customers/Etebar.png": 1095,
	"./ManagedService/Customers/Mapna-gray.png": 1096,
	"./ManagedService/Customers/Sina- gray.png": 1097,
	"./ManagedService/Customers/Sina.png": 1098,
	"./ManagedService/Customers/afam-color.png": 1099,
	"./ManagedService/Customers/afam-gray.png": 1100,
	"./ManagedService/Customers/banner-eseminar.webp": 1101,
	"./ManagedService/Customers/banner-helal.webp": 1102,
	"./ManagedService/Customers/banner-kale.webp": 1103,
	"./ManagedService/Customers/banner-mapna.webp": 1104,
	"./ManagedService/Customers/bime.webp": 1105,
	"./ManagedService/Customers/eseminar-d.webp": 1106,
	"./ManagedService/Customers/eseminar.webp": 1107,
	"./ManagedService/Customers/helal-d.webp": 1108,
	"./ManagedService/Customers/helal.webp": 1109,
	"./ManagedService/Customers/industry.webp": 1110,
	"./ManagedService/Customers/it.webp": 1111,
	"./ManagedService/Customers/kale-d.webp": 1112,
	"./ManagedService/Customers/kale.webp": 1113,
	"./ManagedService/Customers/mapna-color.png": 1114,
	"./ManagedService/Customers/mapna-d.webp": 1115,
	"./ManagedService/Customers/mapna.webp": 1116,
	"./ManagedService/Customers/software.webp": 1117,
	"./ManagedService/Direct.svg": 1167,
	"./ManagedService/Django.svg": 1168,
	"./ManagedService/Elsstic.svg": 1169,
	"./ManagedService/Jira.svg": 1170,
	"./ManagedService/MariaDB.svg": 1171,
	"./ManagedService/Maskgroup.svg": 1133,
	"./ManagedService/Microsoft.svg": 1172,
	"./ManagedService/MongoDB.svg": 1173,
	"./ManagedService/Moodle.svg": 1174,
	"./ManagedService/MySQL.svg": 1175,
	"./ManagedService/Neo4j.svg": 1176,
	"./ManagedService/Opencart.svg": 1177,
	"./ManagedService/Plone.svg": 1178,
	"./ManagedService/PostgreSQL.svg": 1179,
	"./ManagedService/R1.svg": 914,
	"./ManagedService/R2.svg": 915,
	"./ManagedService/R3.svg": 916,
	"./ManagedService/R4.svg": 917,
	"./ManagedService/REDMINE.svg": 1180,
	"./ManagedService/Rocket.svg": 1181,
	"./ManagedService/Step1-m.svg": 1182,
	"./ManagedService/Step1.svg": 1183,
	"./ManagedService/Step2-m.svg": 1184,
	"./ManagedService/Step2.svg": 1185,
	"./ManagedService/Step3.svg": 1186,
	"./ManagedService/Wordmark.svg": 1187,
	"./ManagedService/agility.svg": 1188,
	"./ManagedService/avatar.svg": 1189,
	"./ManagedService/avatar2.svg": 1190,
	"./ManagedService/avatar3.svg": 1191,
	"./ManagedService/avatar4.svg": 1192,
	"./ManagedService/avatar5.svg": 1193,
	"./ManagedService/cancle.svg": 1194,
	"./ManagedService/centralized.svg": 1195,
	"./ManagedService/configuration.svg": 1196,
	"./ManagedService/devops.svg": 1197,
	"./ManagedService/enterprise.svg": 1198,
	"./ManagedService/exclusive.svg": 1199,
	"./ManagedService/focus.svg": 1200,
	"./ManagedService/hardening.svg": 1201,
	"./ManagedService/header.svg": 880,
	"./ManagedService/hero.svg": 1147,
	"./ManagedService/iRedMail.svg": 1202,
	"./ManagedService/joomla.svg": 1203,
	"./ManagedService/laravel.svg": 1204,
	"./ManagedService/managed_service.png": 1205,
	"./ManagedService/managedservices_catalogue.png": 1206,
	"./ManagedService/monitor.svg": 1207,
	"./ManagedService/monitoring.svg": 1208,
	"./ManagedService/osCommerce.svg": 1209,
	"./ManagedService/prometheus.svg": 1210,
	"./ManagedService/redis.svg": 1211,
	"./ManagedService/section-header.svg": 959,
	"./ManagedService/technical.svg": 1212,
	"./ManagedService/tick.svg": 918,
	"./ManagedService/tick1.svg": 1213,
	"./ManagedService/woocommerce.svg": 1214,
	"./Pack1/Back.png": 1952,
	"./Pack1/Back1.svg": 1953,
	"./Pack1/CloudServer.png": 1954,
	"./Pack1/CloudServer.svg": 1955,
	"./Pack1/Server1.svg": 1956,
	"./Pack1/Server2.svg": 1957,
	"./Pack1/Server3.svg": 1958,
	"./Pack1/server1.png": 1959,
	"./Pack1/server2.png": 1960,
	"./Pack1/server3.png": 1961,
	"./Pack1/svg/Back1.svg": 1962,
	"./Pack1/svg/CloudServer.svg": 1963,
	"./Pack1/svg/Server1.svg": 1964,
	"./Pack1/svg/Server2.svg": 1965,
	"./Pack1/svg/Server3.svg": 1966,
	"./Pack2/Back1.svg": 1967,
	"./Pack2/Back2.png": 1968,
	"./Pack2/Security1.svg": 1969,
	"./Pack2/Security2.svg": 1970,
	"./Pack2/security1.png": 1971,
	"./Pack2/security2.png": 1972,
	"./Pack2/svg/Back1.svg": 1973,
	"./Pack2/svg/Security1.svg": 1974,
	"./Pack2/svg/Security2.svg": 1975,
	"./Pack3/Back1.svg": 1976,
	"./Pack3/Back2.png": 1977,
	"./Pack3/Support.png": 1978,
	"./Pack3/Support.svg": 1979,
	"./Pack3/svg/Back1.svg": 1980,
	"./Pack3/svg/Support.svg": 1981,
	"./Pack4/P1.png": 1982,
	"./Pack4/P1.svg": 1983,
	"./Pack4/P12.png": 1984,
	"./Pack4/P2.png": 1985,
	"./Pack4/P2.svg": 1986,
	"./Pack4/P22.png": 1987,
	"./Pack4/P3.png": 1988,
	"./Pack4/P3.svg": 1989,
	"./Pack5/managed.png": 1990,
	"./Pack5/private.png": 1991,
	"./Pack5/server.png": 1992,
	"./Pack5/svg/managed.svg": 1993,
	"./Pack5/svg/private.svg": 1994,
	"./Pack5/svg/vpc.svg": 1995,
	"./Pack5/svg/vps.svg": 1996,
	"./Pack5/vpc.png": 1997,
	"./Slider/Back.png": 1998,
	"./Slider/Back.svg": 1999,
	"./Slider/CloudMain.png": 2000,
	"./Slider/CloudMain.svg": 2001,
	"./Slider/Group368.png": 2002,
	"./Slider/Group368.svg": 2003,
	"./Slider/Group383.svg": 2004,
	"./Slider/Part1.png": 2005,
	"./Slider/Part1.svg": 2006,
	"./Slider/Part2.png": 2007,
	"./Slider/Part2.svg": 2008,
	"./Slider/VPC.png": 2009,
	"./Slider/VPC.svg": 2010,
	"./Slider/cloud.png": 2011,
	"./Slider/cloud.svg": 2012,
	"./Slider/managed.png": 2013,
	"./Slider/managed.svg": 2014,
	"./Technicals/1.png": 2015,
	"./Technicals/11.png": 2016,
	"./Technicals/12.png": 2017,
	"./Technicals/2.png": 2018,
	"./Technicals/3.png": 2019,
	"./Technicals/4.png": 2020,
	"./Technicals/5.png": 2021,
	"./Technicals/6.png": 2022,
	"./Technicals/7.png": 2023,
	"./Technicals/8.png": 2024,
	"./Technicals/9.png": 2025,
	"./Technicals/Technicals10.png": 2026,
	"./VPC/1.png": 1017,
	"./VPC/10.png": 1018,
	"./VPC/11.png": 1019,
	"./VPC/2.png": 1020,
	"./VPC/3.png": 1021,
	"./VPC/4.png": 1022,
	"./VPC/5.png": 1023,
	"./VPC/6.png": 1024,
	"./VPC/7.png": 1025,
	"./VPC/Api.svg": 1026,
	"./VPC/CloudCanvas.svg": 1027,
	"./VPC/Customers/VPC-IT.jpg": 948,
	"./VPC/Customers/VPC-banks.jpg": 949,
	"./VPC/Customers/VPC-innovation.jpg": 950,
	"./VPC/Customers/VPC-insurance.jpg": 951,
	"./VPC/Firewall.svg": 1028,
	"./VPC/LoadBalancers.svg": 1029,
	"./VPC/NetworkTopology.svg": 1030,
	"./VPC/Step1-m.svg": 1031,
	"./VPC/Step1.svg": 1032,
	"./VPC/Step2-m.svg": 1011,
	"./VPC/Step2.svg": 1012,
	"./VPC/Step3.svg": 1013,
	"./VPC/VPC-Main.svg": 1033,
	"./VPC/VPC_Info.svg": 1034,
	"./VPC/VS.svg": 876,
	"./VPC/VirtualMachins.svg": 1035,
	"./VPC/Volumes.svg": 1036,
	"./VPC/backup.svg": 1037,
	"./VPC/blancing.svg": 1038,
	"./VPC/cancle.svg": 877,
	"./VPC/cloud-security.svg": 1039,
	"./VPC/cloudstorage.svg": 881,
	"./VPC/cover-video.jpg": 1040,
	"./VPC/dashboard.svg": 1041,
	"./VPC/datacenter.svg": 882,
	"./VPC/firewall.png": 1042,
	"./VPC/freeSupport.svg": 1043,
	"./VPC/header.svg": 913,
	"./VPC/hq.svg": 1044,
	"./VPC/image.svg": 1045,
	"./VPC/improve.svg": 1046,
	"./VPC/infrustructure.svg": 1047,
	"./VPC/ip.png": 1048,
	"./VPC/network.png": 1049,
	"./VPC/openstack.svg": 1050,
	"./VPC/platform.png": 1051,
	"./VPC/sazman.svg": 1052,
	"./VPC/sdn.svg": 1053,
	"./VPC/section-header.svg": 1054,
	"./VPC/security.svg": 1055,
	"./VPC/service-mgs.svg": 1056,
	"./VPC/signup.svg": 1057,
	"./VPC/sla.svg": 1058,
	"./VPC/snapshot.svg": 1059,
	"./VPC/store.svg": 1060,
	"./VPC/support.svg": 1061,
	"./VPC/tick.svg": 878,
	"./VPC/video.png": 1062,
	"./VPC/vpc-patform.png": 1063,
	"./VPC/vpc1.png": 1064,
	"./VPC/vpc10.png": 1065,
	"./VPC/vpc100.png": 1066,
	"./VPC/vpc11.png": 1067,
	"./VPC/vpc12.png": 1068,
	"./VPC/vpc13.png": 1069,
	"./VPC/vpc15.png": 1070,
	"./VPC/vpc17.png": 1071,
	"./VPC/vpc18.png": 1072,
	"./VPC/vpc19.png": 1073,
	"./VPC/vpc2.png": 1074,
	"./VPC/vpc3.png": 1075,
	"./VPC/vpc4.png": 1076,
	"./VPC/vpc5.png": 1077,
	"./VPC/vpc_platform.png": 1078,
	"./VPS/1minute.svg": 761,
	"./VPS/24.svg": 762,
	"./VPS/AlmaLinux.svg": 763,
	"./VPS/Customers/VPS-foods.jpg": 753,
	"./VPS/Customers/VPS-khandevane.jpg": 754,
	"./VPS/Customers/VPS-manufacturing-firms.jpg": 755,
	"./VPS/Customers/VPS-sunich.jpg": 756,
	"./VPS/Feature-3.svg": 764,
	"./VPS/Feature-4.svg": 765,
	"./VPS/Feature-5.svg": 766,
	"./VPS/Feature-8.svg": 767,
	"./VPS/Fedora.svg": 768,
	"./VPS/Google.svg": 769,
	"./VPS/HA.svg": 770,
	"./VPS/Isolation.svg": 771,
	"./VPS/P1.png": 772,
	"./VPS/P2.png": 773,
	"./VPS/P3.png": 774,
	"./VPS/P4.png": 775,
	"./VPS/P5.png": 776,
	"./VPS/PfSense.svg": 777,
	"./VPS/Rocky_Linux.svg": 778,
	"./VPS/Step1-m.svg": 779,
	"./VPS/Step1.svg": 780,
	"./VPS/Step2-m.svg": 781,
	"./VPS/Step2.svg": 782,
	"./VPS/Step3.svg": 783,
	"./VPS/Successful-Google-Cloud-Migration-1440x564_c 1.svg": 784,
	"./VPS/VPS_Info_.svg": 785,
	"./VPS/ads1.svg": 786,
	"./VPS/ads2.svg": 787,
	"./VPS/apache.svg": 788,
	"./VPS/architect.svg": 789,
	"./VPS/backup.svg": 790,
	"./VPS/calc.png": 791,
	"./VPS/centos.svg": 792,
	"./VPS/chooseOs.svg": 793,
	"./VPS/common-types.svg": 794,
	"./VPS/console.svg": 795,
	"./VPS/container.svg": 796,
	"./VPS/dashboard.svg": 797,
	"./VPS/ddos-c.svg": 798,
	"./VPS/ddos-d.svg": 799,
	"./VPS/ddos.svg": 800,
	"./VPS/debian.svg": 801,
	"./VPS/disaster.svg": 802,
	"./VPS/docker.svg": 803,
	"./VPS/everything.svg": 804,
	"./VPS/externalServer.svg": 805,
	"./VPS/firewall-new.svg": 806,
	"./VPS/firewall.png": 807,
	"./VPS/freeSupport.svg": 808,
	"./VPS/global.svg": 809,
	"./VPS/hq.svg": 810,
	"./VPS/iaas_catalogue.png": 811,
	"./VPS/ico.png": 812,
	"./VPS/image1.svg": 813,
	"./VPS/increase.svg": 814,
	"./VPS/infrustructure.svg": 815,
	"./VPS/ip.png": 816,
	"./VPS/iranServer.svg": 758,
	"./VPS/list-vps.svg": 817,
	"./VPS/mikrotik.svg": 818,
	"./VPS/mysql.svg": 819,
	"./VPS/nStep1-m.svg": 759,
	"./VPS/nStep1.svg": 760,
	"./VPS/nginx.svg": 820,
	"./VPS/nodejs.svg": 821,
	"./VPS/not-found-mobile.svg": 822,
	"./VPS/not-found.svg": 823,
	"./VPS/panel.svg": 824,
	"./VPS/pattern.png": 825,
	"./VPS/plans.svg": 826,
	"./VPS/plans/Maple.svg": 682,
	"./VPS/plans/Willow.svg": 683,
	"./VPS/plans/beech.svg": 684,
	"./VPS/plans/cedar.svg": 685,
	"./VPS/plans/pine.svg": 686,
	"./VPS/plans/poplar.svg": 687,
	"./VPS/platform.png": 827,
	"./VPS/platform2.png": 828,
	"./VPS/python.svg": 829,
	"./VPS/resource.svg": 830,
	"./VPS/service-mgs.svg": 831,
	"./VPS/service-vpc.svg": 832,
	"./VPS/service-vps.svg": 833,
	"./VPS/service.svg": 834,
	"./VPS/siem.svg": 835,
	"./VPS/sla.svg": 836,
	"./VPS/startup.svg": 837,
	"./VPS/support.svg": 838,
	"./VPS/test.svg": 839,
	"./VPS/top-ways.svg": 840,
	"./VPS/traffic-vps.svg": 841,
	"./VPS/ubuntu18.svg": 842,
	"./VPS/ubuntu22.svg": 843,
	"./VPS/uptime.svg": 844,
	"./VPS/video.png": 845,
	"./VPS/vps-header.svg": 752,
	"./VPS/vps-hourly.svg": 757,
	"./VPS/vps-platform.png": 846,
	"./VPS/vps1.png": 847,
	"./VPS/vps10.png": 848,
	"./VPS/vps2.png": 849,
	"./VPS/vps3.png": 850,
	"./VPS/vps4.png": 851,
	"./VPS/vps5.png": 852,
	"./VPS/vps6.png": 853,
	"./VPS/vps7.png": 854,
	"./VPS/vps8.png": 855,
	"./VPS/vps9.png": 856,
	"./VPS/vps_figure.png": 857,
	"./VPS/vps_icon.png": 858,
	"./VPS/vps_picture2.png": 859,
	"./VPS/vpspackage.png": 860,
	"./VPS/waf-c.svg": 861,
	"./VPS/waf-d.svg": 862,
	"./VPS/waf-icon-active.svg": 863,
	"./VPS/waf-icon.svg": 864,
	"./VPS/waf-vps.svg": 865,
	"./VPS/waf.svg": 866,
	"./VPS/windows.svg": 867,
	"./VPS/wordpress.svg": 868,
	"./Xicon.svg": 401,
	"./banners/123.svg": 2027,
	"./banners/Banner-Traffic-Campaign.png": 2028,
	"./banners/Banner.jpg": 2029,
	"./banners/Banner2.jpg": 2030,
	"./banners/Cloud-Database.webp": 2031,
	"./banners/Help.webp": 2032,
	"./banners/Network-Banner.webp": 2033,
	"./banners/Post-1.webp": 2034,
	"./banners/Post-2.webp": 2035,
	"./banners/Post-3.webp": 2036,
	"./banners/SLA.webp": 2037,
	"./banners/VPSvsVDS.webp": 2038,
	"./banners/banner6.svg": 2039,
	"./banners/nowruz-1403-banner.png": 2040,
	"./banners/server-response-time.webp": 2041,
	"./banners/vpc-service.svg": 2042,
	"./banners/yalda-report.png": 2043,
	"./cdn/CDN-Header.svg": 1215,
	"./cdn/Feature-1.svg": 1297,
	"./cdn/Feature-2.svg": 1298,
	"./cdn/Feature-3.svg": 1299,
	"./cdn/Feature-4.svg": 1300,
	"./cdn/Feature-5.svg": 1301,
	"./cdn/Feature-6.svg": 1302,
	"./cdn/Feature-7.svg": 1303,
	"./cdn/Feature-8.svg": 1304,
	"./cdn/IranMap.svg": 1137,
	"./cdn/Malwares_Attackers.svg": 1305,
	"./cdn/access.svg": 1306,
	"./cdn/atactks.svg": 1307,
	"./cdn/cms.svg": 1308,
	"./cdn/company-c.svg": 1309,
	"./cdn/company.svg": 1310,
	"./cdn/customer.svg": 1311,
	"./cdn/ddos-c.svg": 1312,
	"./cdn/ddos-d.svg": 1313,
	"./cdn/ddos.svg": 1314,
	"./cdn/ddosAtacks.svg": 1315,
	"./cdn/domain-c.svg": 1316,
	"./cdn/domain-d.svg": 1317,
	"./cdn/domain.svg": 1318,
	"./cdn/domainss.svg": 1319,
	"./cdn/earth.svg": 1145,
	"./cdn/geography.svg": 1320,
	"./cdn/no.svg": 871,
	"./cdn/price.svg": 1321,
	"./cdn/report-c.svg": 1322,
	"./cdn/report-d.svg": 1323,
	"./cdn/report.svg": 1324,
	"./cdn/scrubbing.svg": 1149,
	"./cdn/seo.svg": 1325,
	"./cdn/speed.svg": 1326,
	"./cdn/ssl.svg": 1327,
	"./cdn/startup-c.svg": 1328,
	"./cdn/startup.svg": 1329,
	"./cdn/store-c.svg": 1330,
	"./cdn/store.svg": 1331,
	"./cdn/tick.svg": 1332,
	"./cdn/uptime.svg": 1333,
	"./cdn/waf-c.svg": 1334,
	"./cdn/waf-d.svg": 1335,
	"./cdn/waf.svg": 1336,
	"./cdn/yes.svg": 872,
	"./cdn/zarb.svg": 1337,
	"./close.svg": 252,
	"./cloudGuard/AutomaticProtection.svg": 2044,
	"./cloudGuard/CreateCustomRules.svg": 2045,
	"./cloudGuard/DDosSection.svg": 2046,
	"./cloudGuard/PermanentAccess.svg": 2047,
	"./cloudGuard/ReducingDistance.svg": 2048,
	"./cloudGuard/SaveResources.svg": 2049,
	"./cloudGuard/WebFirewall.svg": 2050,
	"./cloudGuard/approach.svg": 2051,
	"./cloudGuard/appsAttacks.svg": 2052,
	"./cloudGuard/cdnService.svg": 2053,
	"./cloudGuard/cloudGuard.svg": 2054,
	"./cloudGuard/cloudguard_catalogue.png": 2055,
	"./cloudGuard/company-c.svg": 2056,
	"./cloudGuard/company.svg": 2057,
	"./cloudGuard/ddos-c.svg": 2058,
	"./cloudGuard/ddos-d.svg": 2059,
	"./cloudGuard/ddos.svg": 2060,
	"./cloudGuard/ddosProtection.svg": 2061,
	"./cloudGuard/disasterRecovery.svg": 2062,
	"./cloudGuard/firewall.svg": 2063,
	"./cloudGuard/firewallSetting-c.svg": 2064,
	"./cloudGuard/firewallSetting-d.svg": 2065,
	"./cloudGuard/firewallSetting.svg": 2066,
	"./cloudGuard/freeDNS.svg": 2067,
	"./cloudGuard/iam.svg": 2068,
	"./cloudGuard/infiniteDomain.svg": 2069,
	"./cloudGuard/ip.svg": 2070,
	"./cloudGuard/layer7attacks.svg": 2071,
	"./cloudGuard/limit-c.svg": 2072,
	"./cloudGuard/limit-d.svg": 2073,
	"./cloudGuard/limit.svg": 2074,
	"./cloudGuard/limitedAccess.svg": 2075,
	"./cloudGuard/massAttacks.svg": 2076,
	"./cloudGuard/protection.svg": 2077,
	"./cloudGuard/protocolAttacks.svg": 2078,
	"./cloudGuard/reduceCost.svg": 2079,
	"./cloudGuard/region.svg": 2080,
	"./cloudGuard/savings.svg": 2081,
	"./cloudGuard/scrubbing.svg": 2082,
	"./cloudGuard/security.svg": 2083,
	"./cloudGuard/seo.svg": 2084,
	"./cloudGuard/siem.svg": 2085,
	"./cloudGuard/startup-c.svg": 2086,
	"./cloudGuard/startup.svg": 2087,
	"./cloudGuard/store-c.svg": 2088,
	"./cloudGuard/store.svg": 2089,
	"./cloudGuard/uptime.svg": 2090,
	"./cloudGuard/url.svg": 2091,
	"./cloudGuard/userInfo.svg": 2092,
	"./cloudGuard/waf-c.svg": 2093,
	"./cloudGuard/waf-d.svg": 2094,
	"./cloudGuard/waf.svg": 2095,
	"./cloudMigration/customers/bonyad-shahid.svg": 1722,
	"./cloudMigration/customers/dataak.svg": 1723,
	"./cloudMigration/customers/eita.svg": 1724,
	"./cloudMigration/customers/helal-ahmar-iran.svg": 1725,
	"./colocation/architect.svg": 1908,
	"./colocation/firewall-new.svg": 1909,
	"./colocation/resource.svg": 1910,
	"./colocation/uptime.svg": 1911,
	"./customer/day_logo(1).png": 2096,
	"./customer/day_logo(1).svg": 2097,
	"./customer/farrahicarpet-logo.png": 2098,
	"./customer/farrahicarpet-logo.svg": 2099,
	"./customer/logo-.png": 2100,
	"./customer/logo-.svg": 2101,
	"./customer/logo-hamrahe-aval.png": 2102,
	"./customer/logo-hamrahe-aval.svg": 2103,
	"./customer/logo-kermanmotor-w.png": 2104,
	"./customer/logo-kermanmotor-w.svg": 2105,
	"./customer/snowa_logo.png": 2106,
	"./customer/snowa_logo.svg": 2107,
	"./customer/uniliver(2) 1.png": 2108,
	"./customer/uniliver(2) 1.svg": 2109,
	"./customers/10.png": 2110,
	"./customers/MobileViewLogo-min.png": 2111,
	"./customers/banner/HomePage-IT.webp": 1079,
	"./customers/banner/HomePage-agencies.webp": 1080,
	"./customers/banner/HomePage-banks.webp": 1081,
	"./customers/banner/HomePage-elearning.webp": 1082,
	"./customers/banner/HomePage-foods.webp": 1083,
	"./customers/banner/HomePage-industries.webp": 1084,
	"./customers/banner/HomePage-innovation.webp": 1085,
	"./customers/banner/HomePage-insurance.webp": 1086,
	"./customers/banner/HomePage-manufacturing-firms.webp": 1087,
	"./customers/banner/HomePage-media.webp": 1088,
	"./customers/banner/HomePage-universities.webp": 1089,
	"./customers/banner/Khandevane.png": 1090,
	"./customers/banner/sunich.png": 1091,
	"./customers/bime-day.png": 2112,
	"./customers/eseminar.png": 2113,
	"./customers/khandevane.png": 2114,
	"./customers/logo/Azad.png": 885,
	"./customers/logo/IRISA.png": 886,
	"./customers/logo/Mapna.png": 887,
	"./customers/logo/Samseir.png": 888,
	"./customers/logo/day-insurance-gary.png": 889,
	"./customers/logo/day-insurance.png": 890,
	"./customers/logo/dey.png": 891,
	"./customers/logo/diginext-gray.png": 892,
	"./customers/logo/diginext.png": 893,
	"./customers/logo/eastcool-gray.png": 894,
	"./customers/logo/eastcool-rgb.png": 895,
	"./customers/logo/esiminar.png": 896,
	"./customers/logo/irisa-gray.png": 897,
	"./customers/logo/irisa.png": 898,
	"./customers/logo/istcoll.png": 899,
	"./customers/logo/khandevane-gray.png": 900,
	"./customers/logo/khandevane-rgb.png": 901,
	"./customers/logo/khandevaneh.png": 902,
	"./customers/logo/pars.png": 903,
	"./customers/logo/pegah.png": 904,
	"./customers/logo/persis-foods-gray.png": 905,
	"./customers/logo/persis-foods-rgb.png": 906,
	"./customers/logo/refah.png": 907,
	"./customers/logo/shahr-financial-group-gray.png": 908,
	"./customers/logo/shahr-financial-group.png": 909,
	"./customers/logo/shahr.png": 910,
	"./customers/logo/sunich-gray.png": 911,
	"./customers/logo/sunich-rgb.png": 912,
	"./customers/meydon.png": 2115,
	"./customers/parskh.png": 2116,
	"./customers/parsonline.png": 2117,
	"./customers/refah.png": 2118,
	"./customers/shahr.png": 2119,
	"./customers/t1.png": 2120,
	"./ddosProtection/1.svg": 987,
	"./ddosProtection/2.svg": 988,
	"./ddosProtection/3.svg": 989,
	"./ddosProtection/CloudGuard-Service.svg": 990,
	"./ddosProtection/DNS.svg": 991,
	"./ddosProtection/ManagedService-Service.svg": 992,
	"./ddosProtection/VPC-Service.svg": 993,
	"./ddosProtection/VPS-Service.svg": 994,
	"./ddosProtection/ddos-d.svg": 995,
	"./ddosProtection/ddos-image.svg": 924,
	"./ddosProtection/ddos.svg": 996,
	"./ddosProtection/devops.svg": 997,
	"./ddosProtection/exclusive.svg": 998,
	"./ddosProtection/firewall-ability.1bb527e 1.svg": 999,
	"./ddosProtection/firewall-setting.cc1ac98 1.svg": 1000,
	"./ddosProtection/focus.svg": 1001,
	"./ddosProtection/hardening.svg": 1002,
	"./ddosProtection/limitation.cb39432 1.svg": 1003,
	"./ddosProtection/monitoring.svg": 1004,
	"./ddosProtection/technical.svg": 1005,
	"./ddosProtection/traffic-vps.aa00c67 1.svg": 1006,
	"./ddosProtection/waf-d.svg": 1007,
	"./ddosProtection/waf-icon-active.svg": 1008,
	"./ddosProtection/waf-icon.svg": 1009,
	"./ddosProtection/waf.svg": 1010,
	"./dedicateServer/backup.svg": 2121,
	"./dedicateServer/buy.svg": 2122,
	"./dedicateServer/customized.svg": 2123,
	"./dedicateServer/dedicate-server.svg": 2124,
	"./dedicateServer/internal-cloud.svg": 2125,
	"./dedicateServer/internal.svg": 2126,
	"./dedicateServer/performance.svg": 2127,
	"./dedicateServer/resource.svg": 2128,
	"./dedicateServer/secure.svg": 2129,
	"./dedicateServer/web-hosting.svg": 2130,
	"./dedicatedServer/firewall-new.svg": 1749,
	"./dedicatedServer/image1.svg": 1750,
	"./dedicatedServer/resource.svg": 1751,
	"./dedicatedServer/uptime.svg": 1752,
	"./devops/apps/Ansible.svg": 1753,
	"./devops/apps/Apache-Mesos.svg": 1754,
	"./devops/apps/Apache.svg": 1755,
	"./devops/apps/Cassandra.svg": 1756,
	"./devops/apps/Ceph.svg": 1757,
	"./devops/apps/Chef.svg": 1758,
	"./devops/apps/Datadog.svg": 1759,
	"./devops/apps/Docker-Swarm.svg": 1760,
	"./devops/apps/Elastic-Stack.svg": 1761,
	"./devops/apps/GitLab.svg": 1762,
	"./devops/apps/GlusterFS.svg": 1763,
	"./devops/apps/Grafana.svg": 1764,
	"./devops/apps/IIS.svg": 1765,
	"./devops/apps/Jenkins.svg": 1766,
	"./devops/apps/Kubernetes.svg": 1767,
	"./devops/apps/Lighttpd.svg": 1768,
	"./devops/apps/LiteSpeed.svg": 1769,
	"./devops/apps/MariaDB.svg": 1770,
	"./devops/apps/MinIO.svg": 1771,
	"./devops/apps/MongoDB.svg": 1772,
	"./devops/apps/MySQL.svg": 1773,
	"./devops/apps/NextCloud.svg": 1774,
	"./devops/apps/Nginx.svg": 1775,
	"./devops/apps/OpenShift.svg": 1776,
	"./devops/apps/PostgreSQL.svg": 1777,
	"./devops/apps/Prometheus.svg": 1778,
	"./devops/apps/Puppet.svg": 1779,
	"./devops/apps/Redis.svg": 1780,
	"./devops/apps/Splunk.svg": 1781,
	"./devops/apps/Terraform.svg": 1782,
	"./devops/apps/Tomcat.svg": 1783,
	"./devops/apps/Zabbix.svg": 1784,
	"./devops/customers/Azad-Uni.webp": 1275,
	"./devops/customers/Bank-Sina.webp": 1276,
	"./devops/customers/Iraninan-Poshesh.webp": 1277,
	"./devops/customers/azad-university.svg": 1278,
	"./devops/customers/helal-ahmar.svg": 1279,
	"./devops/customers/helal-ahmar.webp": 1280,
	"./devops/customers/iranian-insurance.svg": 1281,
	"./devops/customers/sina-bank.svg": 1282,
	"./devops/icons/Feature-3.svg": 1118,
	"./devops/icons/Feature-6.svg": 1119,
	"./devops/icons/agility.svg": 1120,
	"./devops/icons/centralized.svg": 1121,
	"./devops/icons/configuration.svg": 1122,
	"./devops/icons/devops.svg": 1123,
	"./devops/icons/enterprise.svg": 1124,
	"./devops/icons/focus.svg": 1125,
	"./devops/icons/hardening.svg": 1126,
	"./devops/icons/hosting.svg": 1127,
	"./devops/icons/monitor.svg": 1128,
	"./devops/icons/monitoring.svg": 1129,
	"./devops/icons/startupLoad.svg": 1130,
	"./devops/icons/technical.svg": 1131,
	"./devops/icons/test.svg": 1132,
	"./devops/images/section-header.svg": 1144,
	"./devops/images/storage.svg": 1338,
	"./dns/DNS-Header.svg": 1267,
	"./dns/Feature-1.svg": 1785,
	"./dns/Feature-2.svg": 1786,
	"./dns/Feature-3.svg": 1787,
	"./dns/Feature-4.svg": 1788,
	"./dns/anyCast.svg": 1789,
	"./dns/dnsPanel.svg": 1790,
	"./dns/noLimit.svg": 1791,
	"./dns/responseDelay.svg": 1792,
	"./dns/unlimitedDomain.svg": 1793,
	"./dnsproxy/logos/AMD.svg": 1431,
	"./dnsproxy/logos/CentOs.svg": 1432,
	"./dnsproxy/logos/DockerHub.svg": 1433,
	"./dnsproxy/logos/ElasticStack.svg": 1434,
	"./dnsproxy/logos/FedoraProject.svg": 1435,
	"./dnsproxy/logos/GitHub.svg": 1436,
	"./dnsproxy/logos/GitLab.svg": 1437,
	"./dnsproxy/logos/Golang.svg": 1438,
	"./dnsproxy/logos/Grafana.svg": 1439,
	"./dnsproxy/logos/Intel.svg": 1440,
	"./dnsproxy/logos/Jenkins.svg": 1441,
	"./dnsproxy/logos/Kubernetes.svg": 1442,
	"./dnsproxy/logos/Microsoft.svg": 1443,
	"./dnsproxy/logos/NVIDIADeveloper.svg": 1444,
	"./dnsproxy/logos/Node.js.svg": 1445,
	"./dnsproxy/logos/Oracle.svg": 1446,
	"./dnsproxy/logos/Prometheus.svg": 1447,
	"./dnsproxy/logos/Python.svg": 1448,
	"./dnsproxy/logos/RedHat.svg": 1449,
	"./dnsproxy/logos/RockyLinux.svg": 1450,
	"./dnsproxy/logos/Splunk.svg": 1451,
	"./dnsproxy/logos/TeamViewer.svg": 1452,
	"./dnsproxy/logos/TensorFlow.svg": 1453,
	"./dnsproxy/logos/Ubuntu.svg": 1454,
	"./dnsproxy/logos/VMware.svg": 1455,
	"./dnsproxy/logos/mongodb.svg": 1456,
	"./dnsproxy/logos/virtualbox.svg": 1457,
	"./enterprise-services/VPC-Main.svg": 1794,
	"./enterprise-services/benefit.svg": 1795,
	"./enterprise-services/header.svg": 1796,
	"./europeVps/24.svg": 1458,
	"./europeVps/CloudGuard-Service.svg": 1459,
	"./europeVps/DNS.svg": 1460,
	"./europeVps/ManagedService-Service.svg": 1461,
	"./europeVps/VPC-Service.svg": 1462,
	"./europeVps/backup.svg": 1463,
	"./europeVps/chooseOs.svg": 1464,
	"./europeVps/console.svg": 1465,
	"./europeVps/dashboard.svg": 1466,
	"./europeVps/ddos-d.svg": 1467,
	"./europeVps/ddos.svg": 1468,
	"./europeVps/disaster.svg": 1469,
	"./europeVps/freeSupport.svg": 1470,
	"./europeVps/global.svg": 1471,
	"./europeVps/hq.svg": 1472,
	"./europeVps/infrustructure.svg": 1473,
	"./europeVps/list-vps.f735948 1.svg": 1474,
	"./europeVps/service.svg": 1475,
	"./europeVps/startup.svg": 1476,
	"./europeVps/traffic-vps.aa00c67 1.svg": 1477,
	"./europeVps/waf-d.svg": 1478,
	"./europeVps/waf-icon-active copy.svg": 1479,
	"./europeVps/waf-icon-active.svg": 1480,
	"./europeVps/waf-icon.svg": 1481,
	"./europeVps/waf-vps.fcecd73 1.svg": 1482,
	"./europeVps/waf.svg": 1483,
	"./events/sari-event-mobile.webp": 1797,
	"./events/sari-event.webp": 1798,
	"./footer.png": 443,
	"./footer/anjoman.svg": 444,
	"./footer/daneshbonyan.svg": 445,
	"./footer/enamad.svg": 446,
	"./footer/fab.svg": 447,
	"./footer/instagram.svg": 448,
	"./footer/linkedin.svg": 449,
	"./footer/location.svg": 450,
	"./footer/nezamsenfi.svg": 451,
	"./footer/occc.svg": 452,
	"./footer/phone.svg": 453,
	"./footer/riasatjomhoori.svg": 454,
	"./footer/telegram.svg": 455,
	"./footer/twitter.svg": 456,
	"./footer/youtube.svg": 457,
	"./form.svg": 402,
	"./header-cropped.svg": 2131,
	"./header/vpc-icon.webp": 1580,
	"./home/Content distribution-c.svg": 2132,
	"./home/Managedservices-c.svg": 2133,
	"./home/Platform-c.svg": 2134,
	"./home/Server-c.svg": 2135,
	"./home/TrafficCampaign.svg": 2136,
	"./home/contentdistribution.svg": 2137,
	"./home/contentdistribution_d.svg": 2138,
	"./home/data center-c.svg": 2139,
	"./home/general_catalogue.png": 2140,
	"./home/live.svg": 2141,
	"./home/manageServices.svg": 2142,
	"./home/manageServices_d.svg": 2143,
	"./home/nowruz-1403-logo.svg": 2144,
	"./home/nowruz.png": 2145,
	"./home/paas.svg": 2146,
	"./home/paas_d.svg": 2147,
	"./home/security-c.svg": 2148,
	"./home/security.svg": 2149,
	"./home/security_d.svg": 2150,
	"./home/shop.svg": 2151,
	"./home/vpc.svg": 2152,
	"./home/vpc_d.svg": 2153,
	"./home/vps.svg": 2154,
	"./home/vps_d.svg": 2155,
	"./home/yalda-m.svg": 2156,
	"./home/yalda.png": 2157,
	"./hourlyVps/1minute.svg": 1484,
	"./hourlyVps/24.svg": 1485,
	"./hourlyVps/CloudGuard-Service.svg": 1486,
	"./hourlyVps/DNS.svg": 1487,
	"./hourlyVps/ManagedService-Service.svg": 1488,
	"./hourlyVps/VPC-Service.svg": 1489,
	"./hourlyVps/chooseOs.svg": 1490,
	"./hourlyVps/console.svg": 1491,
	"./hourlyVps/dashboard.svg": 1492,
	"./hourlyVps/ddos-d.svg": 1493,
	"./hourlyVps/ddos.svg": 1494,
	"./hourlyVps/disaster.svg": 1495,
	"./hourlyVps/firewall-new.svg": 1496,
	"./hourlyVps/freeSupport.svg": 1497,
	"./hourlyVps/global.svg": 1498,
	"./hourlyVps/hq.svg": 1499,
	"./hourlyVps/increase.svg": 1500,
	"./hourlyVps/infrustructure.svg": 1501,
	"./hourlyVps/list-vps.f735948 1.svg": 1502,
	"./hourlyVps/sla.svg": 1503,
	"./hourlyVps/startup.svg": 1504,
	"./hourlyVps/support.svg": 1505,
	"./hourlyVps/test.svg": 1506,
	"./hourlyVps/traffic-vps.aa00c67 1.svg": 1507,
	"./hourlyVps/uptime.svg": 1508,
	"./hourlyVps/virtualOrganization.svg": 1509,
	"./hourlyVps/waf-d.svg": 1510,
	"./hourlyVps/waf-icon-active.svg": 1511,
	"./hourlyVps/waf-icon.svg": 1512,
	"./hourlyVps/waf-vps.fcecd73 1.svg": 1513,
	"./hourlyVps/waf.svg": 1514,
	"./icons/1.png": 689,
	"./icons/2.png": 690,
	"./icons/3.png": 691,
	"./icons/4.png": 692,
	"./icons/5.png": 693,
	"./icons/5.svg": 694,
	"./icons/6.png": 695,
	"./icons/7.png": 696,
	"./icons/CloudGuard-Service.svg": 697,
	"./icons/DNS.svg": 698,
	"./icons/GoDown.png": 699,
	"./icons/GoDown.svg": 700,
	"./icons/GoTop.png": 701,
	"./icons/GoTop.svg": 702,
	"./icons/Group 420.png": 703,
	"./icons/Group 420.svg": 704,
	"./icons/Group 78.png": 705,
	"./icons/Group 78.svg": 706,
	"./icons/Group.png": 707,
	"./icons/Insta.png": 708,
	"./icons/ManagedService-Service.svg": 709,
	"./icons/VPC-Service.svg": 710,
	"./icons/VPS-Service.svg": 711,
	"./icons/anjoman_s.png": 712,
	"./icons/anjoman_s.svg": 713,
	"./icons/bar.svg": 714,
	"./icons/cloud-dns.svg": 715,
	"./icons/contact.png": 716,
	"./icons/contact.svg": 688,
	"./icons/daneshbonyan.png": 717,
	"./icons/daneshbonyan.svg": 718,
	"./icons/ddos.svg": 719,
	"./icons/discount.png": 720,
	"./icons/discount.svg": 721,
	"./icons/enamad-logo.png": 722,
	"./icons/enamad-logo.svg": 723,
	"./icons/facebook.png": 724,
	"./icons/facebook.svg": 725,
	"./icons/github.png": 726,
	"./icons/github.svg": 727,
	"./icons/insta.svg": 728,
	"./icons/instagram.png": 729,
	"./icons/instagram.svg": 730,
	"./icons/linked.svg": 731,
	"./icons/linkedin.png": 732,
	"./icons/linkedin.svg": 733,
	"./icons/new/xaas-instagram.png": 734,
	"./icons/new/xaas-linkedin.png": 735,
	"./icons/new/xaas-telegram.png": 736,
	"./icons/new/xaas-twitter.png": 737,
	"./icons/new/xaas-youtube.png": 738,
	"./icons/nezam-senfi.png": 739,
	"./icons/nezam-senfi.svg": 740,
	"./icons/quote.png": 679,
	"./icons/showMore.svg": 674,
	"./icons/tweet.svg": 741,
	"./icons/tweter.png": 742,
	"./icons/twitter.png": 743,
	"./icons/twitter.svg": 744,
	"./icons/vps_icon2.png": 745,
	"./icons/xaas-fab.png": 746,
	"./icons/xaas-fab.svg": 747,
	"./icons/xaas-occc.png": 748,
	"./icons/xaas-occc.svg": 749,
	"./icons/xaas-riasat-jomhoori.png": 750,
	"./icons/xaas-riasat-jomhoori.svg": 751,
	"./img1.png": 1799,
	"./img2.png": 2158,
	"./isolatedCloud/CloudGuard-Service.svg": 925,
	"./isolatedCloud/Feature-1.svg": 926,
	"./isolatedCloud/Feature-2.svg": 927,
	"./isolatedCloud/Feature-3.svg": 928,
	"./isolatedCloud/Feature-4.svg": 929,
	"./isolatedCloud/Feature-5.svg": 930,
	"./isolatedCloud/Feature-6.svg": 931,
	"./isolatedCloud/Feature-7.svg": 932,
	"./isolatedCloud/Feature-8.svg": 933,
	"./isolatedCloud/ManagedService-Service.svg": 934,
	"./isolatedCloud/VPC-Service.svg": 935,
	"./isolatedCloud/VPS-Service.svg": 936,
	"./isolatedCloud/advancedSecurity.svg": 937,
	"./isolatedCloud/backup.svg": 938,
	"./isolatedCloud/disaster.svg": 939,
	"./isolatedCloud/easyBuy.svg": 940,
	"./isolatedCloud/easyUse.svg": 941,
	"./isolatedCloud/hunezarat.svg": 922,
	"./isolatedCloud/liveMigration.svg": 942,
	"./isolatedCloud/reliability.svg": 943,
	"./isolatedCloud/service.svg": 944,
	"./isolatedCloud/startup.svg": 945,
	"./isolatedCloud/test.svg": 946,
	"./isolatedCloud/virtualOrganization.svg": 947,
	"./landing/1045479.svg": 2159,
	"./landing/2906274.svg": 2160,
	"./landing/860238.svg": 2161,
	"./landing/860239.svg": 2162,
	"./landing/Group 12.svg": 2163,
	"./landing/Group 13.svg": 2164,
	"./landing/Group 14.svg": 2165,
	"./landing/Group 15.svg": 2166,
	"./landing/Group 16.webp": 2167,
	"./landing/Group 17.svg": 2168,
	"./landing/Group.svg": 2169,
	"./landing/Xaas.svg": 2170,
	"./landing/abr.svg": 2171,
	"./landing/avatar.svg": 2172,
	"./landing/background.png": 2173,
	"./landing/button.svg": 2174,
	"./landing/chamedoon.png": 2175,
	"./landing/cloud.svg": 2176,
	"./landing/data-analysis.svg": 2177,
	"./landing/landing.jpg": 2178,
	"./landing/project-analysis.svg": 2179,
	"./landing/shield.svg": 2180,
	"./landing/small-screen-arrow.svg": 2181,
	"./landing/web-security.svg": 2182,
	"./linuxVps/1minute.svg": 1581,
	"./linuxVps/24.svg": 1582,
	"./linuxVps/CloudGuard-Service.svg": 1583,
	"./linuxVps/DNS.svg": 1584,
	"./linuxVps/ManagedService-Service.svg": 1585,
	"./linuxVps/VPC-Service.svg": 1586,
	"./linuxVps/chooseOs.svg": 1587,
	"./linuxVps/console.svg": 1588,
	"./linuxVps/dashboard.svg": 1589,
	"./linuxVps/ddos-d.svg": 1590,
	"./linuxVps/ddos.svg": 1591,
	"./linuxVps/firewall-new.svg": 1592,
	"./linuxVps/freeSupport.svg": 1593,
	"./linuxVps/global.svg": 1594,
	"./linuxVps/hq.svg": 1595,
	"./linuxVps/increase.svg": 1596,
	"./linuxVps/infrustructure.svg": 1597,
	"./linuxVps/list-vps.f735948 1.svg": 1598,
	"./linuxVps/sla.svg": 1599,
	"./linuxVps/support.svg": 1600,
	"./linuxVps/traffic-vps.aa00c67 1.svg": 1601,
	"./linuxVps/uptime.svg": 1602,
	"./linuxVps/waf-d.svg": 1603,
	"./linuxVps/waf-icon-active.svg": 1604,
	"./linuxVps/waf-icon.svg": 1605,
	"./linuxVps/waf-vps.fcecd73 1.svg": 1606,
	"./linuxVps/waf.svg": 1607,
	"./logo-w.svg": 2183,
	"./logo.svg": 1608,
	"./menu-icons/addons.svg": 404,
	"./menu-icons/blog.svg": 405,
	"./menu-icons/calc.svg": 406,
	"./menu-icons/cdn.svg": 407,
	"./menu-icons/cdn24.svg": 408,
	"./menu-icons/cloud-network.svg": 409,
	"./menu-icons/combination-cloud.svg": 410,
	"./menu-icons/company-size.svg": 411,
	"./menu-icons/coprate.svg": 412,
	"./menu-icons/ddos.svg": 413,
	"./menu-icons/digital-tahavol.svg": 414,
	"./menu-icons/faq.svg": 415,
	"./menu-icons/free.svg": 416,
	"./menu-icons/how-to-start.svg": 417,
	"./menu-icons/in-xaas.svg": 418,
	"./menu-icons/industry.svg": 419,
	"./menu-icons/infra.svg": 420,
	"./menu-icons/left15.svg": 421,
	"./menu-icons/left7.svg": 422,
	"./menu-icons/main3.svg": 423,
	"./menu-icons/manage.svg": 424,
	"./menu-icons/manage24.svg": 425,
	"./menu-icons/migrate.svg": 426,
	"./menu-icons/organ-docs.svg": 427,
	"./menu-icons/organ-security.svg": 428,
	"./menu-icons/organ-solutions.svg": 429,
	"./menu-icons/organization.svg": 430,
	"./menu-icons/paas.svg": 431,
	"./menu-icons/prices.svg": 432,
	"./menu-icons/private-cloud.svg": 433,
	"./menu-icons/security.svg": 434,
	"./menu-icons/service-help.svg": 435,
	"./menu-icons/sla.svg": 436,
	"./menu-icons/special.svg": 437,
	"./menu-icons/storage.svg": 438,
	"./menu-icons/tech-services-for-organs.svg": 439,
	"./menu-icons/vpc.svg": 440,
	"./menu-icons/vps.svg": 441,
	"./new_customers/HiMart.png": 2184,
	"./new_customers/amirkabir.png": 2185,
	"./new_customers/azad.png": 2186,
	"./new_customers/bankrefah.png": 2187,
	"./new_customers/bankshahr.png": 2188,
	"./new_customers/barkat.png": 2189,
	"./new_customers/bidbarg.png": 2190,
	"./new_customers/bime-dey.png": 2191,
	"./new_customers/digikala.png": 2192,
	"./new_customers/eastcool.png": 2193,
	"./new_customers/elmosanat.png": 2194,
	"./new_customers/freezone.png": 2195,
	"./new_customers/irisaco.png": 2196,
	"./new_customers/jameazad.png": 2197,
	"./new_customers/javid.png": 2198,
	"./new_customers/khandevane.png": 2199,
	"./new_customers/madiran.png": 2200,
	"./new_customers/mahran.png": 2201,
	"./new_customers/mashal.png": 2202,
	"./new_customers/meydon.png": 2203,
	"./new_customers/mofid.png": 2204,
	"./new_customers/netbarg.png": 2205,
	"./new_customers/parskhazar.png": 2206,
	"./new_customers/parsonline.png": 2207,
	"./new_customers/pegah.png": 2208,
	"./new_customers/pejoheshgah.png": 2209,
	"./new_customers/samseir.png": 2210,
	"./new_customers/tanzim.png": 2211,
	"./organizationalSolution/24.svg": 1339,
	"./organizationalSolution/CDN-Header.svg": 923,
	"./organizationalSolution/CloudGuard-Service.svg": 1340,
	"./organizationalSolution/DNS.svg": 1341,
	"./organizationalSolution/HA.svg": 1342,
	"./organizationalSolution/Isolation.svg": 1343,
	"./organizationalSolution/ManagedService-Service.svg": 1344,
	"./organizationalSolution/VPC-Main.svg": 1283,
	"./organizationalSolution/VPC-Service.svg": 1345,
	"./organizationalSolution/architect.svg": 1346,
	"./organizationalSolution/backup.svg": 1347,
	"./organizationalSolution/blancing.svg": 1348,
	"./organizationalSolution/chooseOs.svg": 1349,
	"./organizationalSolution/container.svg": 1350,
	"./organizationalSolution/dashboard.svg": 1351,
	"./organizationalSolution/ddos-image.svg": 1284,
	"./organizationalSolution/devops.svg": 1352,
	"./organizationalSolution/freeSupport.svg": 1353,
	"./organizationalSolution/global.svg": 1354,
	"./organizationalSolution/header.svg": 1355,
	"./organizationalSolution/improve.svg": 1356,
	"./organizationalSolution/increase.svg": 1357,
	"./organizationalSolution/kuber.svg": 1358,
	"./organizationalSolution/migration.svg": 1359,
	"./organizationalSolution/monitoring.svg": 1360,
	"./organizationalSolution/openstack.svg": 1361,
	"./organizationalSolution/panel.svg": 1362,
	"./organizationalSolution/plans.svg": 1363,
	"./organizationalSolution/resource.svg": 1364,
	"./organizationalSolution/service.svg": 1365,
	"./organizationalSolution/sla.svg": 1366,
	"./organizationalSolution/snapshot.svg": 1367,
	"./organizationalSolution/support.svg": 1368,
	"./paas/1.png": 1800,
	"./paas/1.svg": 1801,
	"./paas/10.svg": 1802,
	"./paas/2.png": 1803,
	"./paas/2.svg": 1804,
	"./paas/3.png": 1805,
	"./paas/3.svg": 1806,
	"./paas/4.png": 1807,
	"./paas/4.svg": 1808,
	"./paas/5.svg": 1609,
	"./paas/6.svg": 1610,
	"./paas/7.svg": 1611,
	"./paas/8.svg": 1809,
	"./paas/9.svg": 1810,
	"./paas/api.svg": 1811,
	"./paas/dashboard.svg": 1812,
	"./paas/esteghrar.svg": 1813,
	"./paas/event.svg": 1814,
	"./paas/logo.svg": 1612,
	"./paas/monitoring.svg": 1815,
	"./paas/scale.svg": 1816,
	"./paas/store.svg": 1817,
	"./paas/support.svg": 1818,
	"./paas/tozie.svg": 1819,
	"./pam/auth2.svg": 1515,
	"./pam/browser.svg": 1516,
	"./pam/control.svg": 1517,
	"./pam/device.svg": 1518,
	"./pam/health.svg": 1519,
	"./pam/impersonate.svg": 1520,
	"./pam/leak.svg": 1521,
	"./pam/limit-access.svg": 1522,
	"./pam/log.svg": 1523,
	"./pam/manage-acc.svg": 1524,
	"./pam/manage-security.svg": 1525,
	"./pam/manage-user.svg": 1526,
	"./pam/manage.svg": 1527,
	"./pam/mfa.svg": 1528,
	"./pam/otp.svg": 1529,
	"./pam/pam.svg": 1530,
	"./pam/prevent.svg": 1531,
	"./pam/protocol.svg": 1532,
	"./pam/record.svg": 1533,
	"./pam/reports.svg": 1534,
	"./pam/users.svg": 1535,
	"./pam/web.svg": 1536,
	"./pomegrante.svg": 2212,
	"./rebranding/catalogue/managed-services-catalogue.webp": 2213,
	"./rebranding/catalogue/solutions-catalogue.webp": 1613,
	"./rebranding/contact/account.svg": 2214,
	"./rebranding/contact/contract.svg": 2215,
	"./rebranding/contact/products.svg": 2216,
	"./rebranding/contact/support.svg": 2217,
	"./rebranding/content/cdn.webp": 1220,
	"./rebranding/content/colocation.webp": 1221,
	"./rebranding/content/ddos.webp": 1222,
	"./rebranding/content/dedicated-server.webp": 1223,
	"./rebranding/content/dns.webp": 1224,
	"./rebranding/content/firewall.webp": 1225,
	"./rebranding/content/graphics-server.webp": 1226,
	"./rebranding/content/local-storage.webp": 1227,
	"./rebranding/content/object-storage.webp": 1228,
	"./rebranding/content/vpc.webp": 1229,
	"./rebranding/content/vps.webp": 1230,
	"./rebranding/content/waf.webp": 1231,
	"./rebranding/customerLogos/1.webp": 1369,
	"./rebranding/customerLogos/10.webp": 1370,
	"./rebranding/customerLogos/11.webp": 1371,
	"./rebranding/customerLogos/12.webp": 1372,
	"./rebranding/customerLogos/13.webp": 1373,
	"./rebranding/customerLogos/14.webp": 1374,
	"./rebranding/customerLogos/15.webp": 1375,
	"./rebranding/customerLogos/16.webp": 1376,
	"./rebranding/customerLogos/17.webp": 1377,
	"./rebranding/customerLogos/18.webp": 1378,
	"./rebranding/customerLogos/19.webp": 1379,
	"./rebranding/customerLogos/2.webp": 1380,
	"./rebranding/customerLogos/20.webp": 1381,
	"./rebranding/customerLogos/21.webp": 1382,
	"./rebranding/customerLogos/22.webp": 1383,
	"./rebranding/customerLogos/23.webp": 1384,
	"./rebranding/customerLogos/24.webp": 1385,
	"./rebranding/customerLogos/25.webp": 1386,
	"./rebranding/customerLogos/26.webp": 1387,
	"./rebranding/customerLogos/27.webp": 1388,
	"./rebranding/customerLogos/28.webp": 1389,
	"./rebranding/customerLogos/29.webp": 1390,
	"./rebranding/customerLogos/3.webp": 1391,
	"./rebranding/customerLogos/30.webp": 1392,
	"./rebranding/customerLogos/31.webp": 1393,
	"./rebranding/customerLogos/32.webp": 1394,
	"./rebranding/customerLogos/33.webp": 1395,
	"./rebranding/customerLogos/34.webp": 1396,
	"./rebranding/customerLogos/35.webp": 1397,
	"./rebranding/customerLogos/36.webp": 1398,
	"./rebranding/customerLogos/37.webp": 1399,
	"./rebranding/customerLogos/38.webp": 1400,
	"./rebranding/customerLogos/39.webp": 1401,
	"./rebranding/customerLogos/4.webp": 1402,
	"./rebranding/customerLogos/40.webp": 1403,
	"./rebranding/customerLogos/5.webp": 1404,
	"./rebranding/customerLogos/6.webp": 1405,
	"./rebranding/customerLogos/7.webp": 1406,
	"./rebranding/customerLogos/8.webp": 1407,
	"./rebranding/customerLogos/9.webp": 1408,
	"./rebranding/customers/content/e-seminar.webp": 1409,
	"./rebranding/customers/content/helal-ahmar.webp": 1410,
	"./rebranding/customers/content/ikco.webp": 1411,
	"./rebranding/customers/content/mapna.webp": 1412,
	"./rebranding/customers/content/milli-1.webp": 1413,
	"./rebranding/customers/content/milli.webp": 1414,
	"./rebranding/customers/content/solico.webp": 1415,
	"./rebranding/customers/e-seminar.png": 1614,
	"./rebranding/customers/helal-ahmar.png": 1615,
	"./rebranding/customers/ikco.png": 1616,
	"./rebranding/customers/mapna.png": 1617,
	"./rebranding/customers/milli-gold.png": 1618,
	"./rebranding/customers/solico.png": 1619,
	"./rebranding/heroBackground.webp": 1620,
	"./rebranding/logo/logo-abalon-en.png": 442,
	"./rebranding/logo/logo-abalon-fa.png": 403,
	"./rebranding/logo/logo-blue.svg": 2218,
	"./rebranding/logo/logo-dark.svg": 2219,
	"./rebranding/logo/logo-en-botton-blue.svg": 2220,
	"./rebranding/logo/logo-en-botton-dark.svg": 2221,
	"./rebranding/logo/logo-en-botton-gradiant.svg": 2222,
	"./rebranding/logo/logo-en-botton-white.svg": 2223,
	"./rebranding/logo/logo-en-left-blue.svg": 2224,
	"./rebranding/logo/logo-en-left-dark.svg": 2225,
	"./rebranding/logo/logo-en-left-gradiant.svg": 2226,
	"./rebranding/logo/logo-en-left-white.svg": 2227,
	"./rebranding/logo/logo-fa-botton-blue.svg": 2228,
	"./rebranding/logo/logo-fa-botton-dark.svg": 2229,
	"./rebranding/logo/logo-fa-botton-gradiant.svg": 2230,
	"./rebranding/logo/logo-fa-botton-white.svg": 2231,
	"./rebranding/logo/logo-fa-left-blue.svg": 2232,
	"./rebranding/logo/logo-fa-left-dark.svg": 2233,
	"./rebranding/logo/logo-fa-left-gradiant.svg": 2234,
	"./rebranding/logo/logo-fa-left-white.svg": 2235,
	"./rebranding/logo/logo-gradiant.svg": 2236,
	"./rebranding/logo/logo-white.svg": 2237,
	"./rebranding/pages/1.b820ea4 1.svg": 952,
	"./rebranding/pages/3.32dda95 1.svg": 953,
	"./rebranding/pages/Api.701b548 2.svg": 963,
	"./rebranding/pages/CloudCanvas.82fd9ce 1.svg": 964,
	"./rebranding/pages/Firewall.398439d 1.svg": 965,
	"./rebranding/pages/LoadBalancers.4b40924 1.svg": 966,
	"./rebranding/pages/Logo.svg": 961,
	"./rebranding/pages/NetworkTopology.3e287eb 1.svg": 967,
	"./rebranding/pages/Step1.73148bc.svg": 954,
	"./rebranding/pages/VPC-Main.b1c5b7f.svg": 870,
	"./rebranding/pages/VirtualMachins.217b5d7 1.svg": 968,
	"./rebranding/pages/Volumes.d769ca6 1.svg": 969,
	"./rebranding/pages/WAE.svg": 970,
	"./rebranding/pages/abalon-logo.svg": 971,
	"./rebranding/pages/cloud-platforms.png": 955,
	"./rebranding/pages/ddos-c.7eebc2f 1.svg": 972,
	"./rebranding/pages/dnsPanel.af7f507 1.svg": 956,
	"./rebranding/pages/domain-c.409b389.svg": 973,
	"./rebranding/pages/firewall-ability.1bb527e 1.svg": 974,
	"./rebranding/pages/firewall-ability.1bb527e 2.svg": 975,
	"./rebranding/pages/firewall-setting.cc1ac98 1.svg": 976,
	"./rebranding/pages/header.1b96d2f 1.svg": 960,
	"./rebranding/pages/kuber.png": 957,
	"./rebranding/pages/limitation.cb39432 1.svg": 977,
	"./rebranding/pages/list-vps.f735948 1.svg": 978,
	"./rebranding/pages/map.9a4bec5 1.svg": 958,
	"./rebranding/pages/not-found-mobile.7b6fab4.svg": 672,
	"./rebranding/pages/not-found.4ba4a5c 1.svg": 673,
	"./rebranding/pages/report-c.11b26e7 1.svg": 979,
	"./rebranding/pages/traffic-vps.aa00c67 1.svg": 980,
	"./rebranding/pages/waf-c.6f5be55 1.svg": 981,
	"./rebranding/pages/waf-vps.fcecd73 1.svg": 982,
	"./rebranding/products/card-background-1.webp": 1621,
	"./rebranding/products/card-background-2.webp": 1622,
	"./rebranding/products/card-background.webp": 1157,
	"./rebranding/products2/1.svg": 1623,
	"./rebranding/products2/2.svg": 1624,
	"./rebranding/products2/3.svg": 1625,
	"./rebranding/products2/4.svg": 1626,
	"./rebranding/products2/5.svg": 1627,
	"./rebranding/products2/6.svg": 1628,
	"./rebranding/products2/backup/1.svg": 1629,
	"./rebranding/products2/backup/2.svg": 1630,
	"./rebranding/products2/backup/3.svg": 1631,
	"./rebranding/products2/backup/4.svg": 1632,
	"./rebranding/products2/backup/5.svg": 1633,
	"./rebranding/products2/backup/6.svg": 1634,
	"./rebranding/products2/backup/primary.svg": 1635,
	"./rebranding/products2/devops/1.svg": 1636,
	"./rebranding/products2/devops/2.svg": 1637,
	"./rebranding/products2/devops/3.svg": 1638,
	"./rebranding/products2/devops/4.svg": 1639,
	"./rebranding/products2/devops/5.svg": 1640,
	"./rebranding/products2/devops/6.svg": 1641,
	"./rebranding/products2/devops/primary.svg": 1642,
	"./rebranding/products2/kuber/1.svg": 1643,
	"./rebranding/products2/kuber/2.svg": 1644,
	"./rebranding/products2/kuber/3.svg": 1645,
	"./rebranding/products2/kuber/4.svg": 1646,
	"./rebranding/products2/kuber/5.svg": 1647,
	"./rebranding/products2/kuber/6.svg": 1648,
	"./rebranding/products2/migration/1.svg": 1649,
	"./rebranding/products2/migration/2.svg": 1650,
	"./rebranding/products2/migration/3.svg": 1651,
	"./rebranding/products2/migration/4.svg": 1652,
	"./rebranding/products2/migration/5.svg": 1653,
	"./rebranding/products2/migration/6.svg": 1654,
	"./rebranding/products2/migration/primary.svg": 1655,
	"./rebranding/products2/privateCloud/1.svg": 1656,
	"./rebranding/products2/privateCloud/2.svg": 1657,
	"./rebranding/products2/privateCloud/3.svg": 1658,
	"./rebranding/products2/privateCloud/4.svg": 1659,
	"./rebranding/products2/privateCloud/5.svg": 1660,
	"./rebranding/products2/privateCloud/6.svg": 1661,
	"./rebranding/products2/privateCloud/primary.svg": 1662,
	"./rebranding/products2/productsPrimaryBackground.png": 1663,
	"./rebranding/products2/secureCloud/1.svg": 1664,
	"./rebranding/products2/secureCloud/2.svg": 1665,
	"./rebranding/products2/secureCloud/3.svg": 1666,
	"./rebranding/products2/secureCloud/4.svg": 1667,
	"./rebranding/products2/secureCloud/5.svg": 1668,
	"./rebranding/products2/secureCloud/6.svg": 1669,
	"./rebranding/products2/secureCloud/primary.svg": 1670,
	"./rebranding/products2/security/1.svg": 1671,
	"./rebranding/products2/security/2.svg": 1672,
	"./rebranding/products2/security/3.svg": 1673,
	"./rebranding/products2/security/4.svg": 1674,
	"./rebranding/products2/security/5.svg": 1675,
	"./rebranding/products2/security/6.svg": 1676,
	"./rebranding/products2/security/primary.svg": 1677,
	"./rebranding/services/services-image.webp": 1678,
	"./rebranding/statisticsBackground.webp": 1679,
	"./sectionTwo/section1.svg": 2238,
	"./security/1.svg": 1820,
	"./security/10.svg": 1821,
	"./security/11.svg": 1822,
	"./security/12.svg": 1823,
	"./security/13.svg": 1824,
	"./security/14.svg": 1825,
	"./security/15.svg": 1826,
	"./security/16.svg": 1827,
	"./security/17.svg": 1828,
	"./security/18.svg": 1829,
	"./security/2.svg": 1830,
	"./security/3.svg": 1831,
	"./security/4.svg": 1832,
	"./security/5.svg": 1833,
	"./security/6.svg": 1834,
	"./security/7.svg": 1835,
	"./security/8.svg": 1836,
	"./security/9.svg": 1837,
	"./security/WAF.svg": 1838,
	"./security/ddos-ability.svg": 1839,
	"./security/ddos-image.svg": 1680,
	"./security/ddos.svg": 1840,
	"./security/dlp.svg": 1841,
	"./security/dmz.svg": 1842,
	"./security/dr.svg": 1843,
	"./security/firewall-ability.svg": 1844,
	"./security/firewall-image.svg": 1537,
	"./security/firewall-setting.svg": 1845,
	"./security/firewall-web.svg": 1846,
	"./security/firewall.svg": 1847,
	"./security/header-image.svg": 1158,
	"./security/hunezarat.svg": 1093,
	"./security/iam.svg": 1848,
	"./security/items-1.svg": 1849,
	"./security/limitation.png": 1850,
	"./security/limitation.svg": 1851,
	"./security/private.svg": 1852,
	"./security/sandbox.svg": 1853,
	"./security/scan.svg": 1854,
	"./security/sec2-mobile.svg": 1855,
	"./security/sec2.svg": 1856,
	"./security/siem.svg": 1857,
	"./security/virus.svg": 1858,
	"./security/waf-banner.svg": 962,
	"./service_icons/1.jpg": 2239,
	"./service_icons/10.jpg": 2240,
	"./service_icons/11.jpg": 2241,
	"./service_icons/12.jpg": 2242,
	"./service_icons/13.jpg": 2243,
	"./service_icons/14.jpg": 2244,
	"./service_icons/15.jpg": 2245,
	"./service_icons/16.jpg": 2246,
	"./service_icons/17.jpg": 2247,
	"./service_icons/18.jpg": 2248,
	"./service_icons/19.jpg": 2249,
	"./service_icons/2.jpg": 2250,
	"./service_icons/20.jpg": 2251,
	"./service_icons/21.jpg": 2252,
	"./service_icons/22.jpg": 2253,
	"./service_icons/23.jpg": 2254,
	"./service_icons/24.jpg": 2255,
	"./service_icons/25.jpg": 2256,
	"./service_icons/26.jpg": 2257,
	"./service_icons/27.jpg": 2258,
	"./service_icons/28.jpg": 2259,
	"./service_icons/3.jpg": 2260,
	"./service_icons/4.jpg": 2261,
	"./service_icons/5.jpg": 2262,
	"./service_icons/6.jpg": 2263,
	"./service_icons/7.jpg": 2264,
	"./service_icons/8.jpg": 2265,
	"./service_icons/9.jpg": 2266,
	"./siem/Acunetix.svg": 1538,
	"./siem/Arista-Networks.svg": 1539,
	"./siem/Barracuda-NextGen.svg": 1540,
	"./siem/Barracuda.svg": 1541,
	"./siem/Bitdefender-GravityZone.svg": 1542,
	"./siem/Cisco-ASA.svg": 1543,
	"./siem/CrowdStrike-Falcon.svg": 1544,
	"./siem/CyberArk.svg": 1545,
	"./siem/F5-Network.svg": 1546,
	"./siem/Fortinet.svg": 1547,
	"./siem/Juniper-SRX.svg": 1548,
	"./siem/Kaspersky-Endpoint-Security.svg": 1549,
	"./siem/Manageengine-IPFIX.svg": 1550,
	"./siem/McAfee-MVISION-EDR.svg": 1551,
	"./siem/Metasploit.svg": 1552,
	"./siem/MikroTik-RouterOS.svg": 1553,
	"./siem/Nmap.svg": 1554,
	"./siem/Paessler-NetFlow.svg": 1555,
	"./siem/Palo-Alto-NGFW.svg": 1556,
	"./siem/Qualys.svg": 1557,
	"./siem/Rapid7-Nexpose.svg": 1558,
	"./siem/SonicWall-TZ.svg": 1559,
	"./siem/Sophos-Intercept- X.svg": 1560,
	"./siem/Tenable-Nessus.svg": 1561,
	"./siem/Trend-Micro-Apex-One.svg": 1562,
	"./siem/Ubiquiti-UniFi.svg": 1563,
	"./siem/Wireshark.svg": 1564,
	"./siem/palo-alto-networks.svg": 1565,
	"./slider.jpg": 2267,
	"./solutions/digital-tahavol.svg": 1859,
	"./solutions/organization-cloud.svg": 1860,
	"./solutions/organization-security.svg": 1861,
	"./solutions/organization-solutions.svg": 1862,
	"./solutions/orgranization-services.svg": 1863,
	"./svg/Banner.jpg": 2268,
	"./svg/Group409.svg": 2269,
	"./svg/Rectangle1.png": 2270,
	"./svg/Rectangle2.png": 2271,
	"./svg/Rectangle3.png": 2272,
	"./svg/Rectangle4.png": 2273,
	"./svg/benefit.svg": 875,
	"./svg/cloud.svg": 874,
	"./svg/not-found.png": 2274,
	"./svg/plan.svg": 2275,
	"./svg/slider-bg.svg": 1092,
	"./videos/vpc-video.mp4": 2276,
	"./videos/vps-video.mp4": 2277,
	"./virtualServer/Feature-1.svg": 1232,
	"./virtualServer/Feature-2.svg": 1233,
	"./virtualServer/Feature-3.svg": 1234,
	"./virtualServer/Feature-4.svg": 1235,
	"./virtualServer/Feature-5.svg": 1236,
	"./virtualServer/Feature-6.svg": 1237,
	"./virtualServer/Feature-7.svg": 1238,
	"./virtualServer/Feature-8.svg": 1239,
	"./virtualServer/Step1-m.svg": 1216,
	"./virtualServer/Step1.svg": 1217,
	"./virtualServer/Step2-m.svg": 1150,
	"./virtualServer/Step2.svg": 1151,
	"./virtualServer/Step3.svg": 1152,
	"./virtualServer/advancedSecurity.svg": 1240,
	"./virtualServer/backup.svg": 1241,
	"./virtualServer/easyBuy.svg": 1242,
	"./virtualServer/easyUse.svg": 1243,
	"./virtualServer/externalServer.svg": 1244,
	"./virtualServer/focus.svg": 1245,
	"./virtualServer/hosting.svg": 1246,
	"./virtualServer/hourlyServer.svg": 1218,
	"./virtualServer/iranServer.svg": 1247,
	"./virtualServer/liveMigration.svg": 1248,
	"./virtualServer/noLimit.svg": 1249,
	"./virtualServer/reliability.svg": 1250,
	"./virtualServer/siem.svg": 1251,
	"./virtualServer/startupLoad.svg": 1252,
	"./virtualServer/test.svg": 1253,
	"./virtualServer/virtual-server.svg": 1014,
	"./virtualServer/virtualDesktop.svg": 1254,
	"./virtualServer/virtualOrganization.svg": 1255,
	"./vps-icons/ManagedService-head.png": 2278,
	"./vps-icons/ManagedService.png": 2279,
	"./vps-icons/P1.png": 2280,
	"./vps-icons/P2.png": 2281,
	"./vps-icons/P3.png": 2282,
	"./vps-icons/P4.png": 2283,
	"./vps-icons/P5.png": 2284,
	"./vps-icons/download.png": 2285,
	"./vps-icons/file.png": 2286,
	"./vps-icons/private-cloud.png": 2287,
	"./vps-icons/private-icon.png": 2288,
	"./vps-icons/vps.png": 2289,
	"./vps-icons/vps_back.png": 2290,
	"./vps-icons/vps_icon.png": 2291,
	"./vps-icons/vps_icon2.png": 2292,
	"./vps-icons/vps_icon_fix.png": 2293,
	"./vps-icons/vps_icon_pic.png": 2294,
	"./vps-icons/vps_ip.png": 2295,
	"./vps-icons/vps_pattern.png": 2296,
	"./vps-icons/vps_pattern2.png": 2297,
	"./vps-icons/vps_picture.png": 2298,
	"./vps-icons/vps_picture2.png": 2299,
	"./vps-icons/vps_picture3.png": 2300,
	"./vps-icons/vps_security.png": 2301,
	"./vps-icons/vps_video.png": 2302,
	"./vps-icons/vpss.png": 2303,
	"./vps-icons/xaas-cloud.png": 2304,
	"./windowsVps/24.svg": 1864,
	"./windowsVps/Feature-1.svg": 1865,
	"./windowsVps/Feature-3.svg": 1866,
	"./windowsVps/benefit.svg": 1681,
	"./windowsVps/centralized.svg": 1867,
	"./windowsVps/chooseOs copy.svg": 1868,
	"./windowsVps/chooseOs.svg": 1869,
	"./windowsVps/configuration.svg": 1870,
	"./windowsVps/console.svg": 1871,
	"./windowsVps/dashboard.svg": 1872,
	"./windowsVps/ddos-d.svg": 1873,
	"./windowsVps/ddos.svg": 1874,
	"./windowsVps/dr.svg": 1875,
	"./windowsVps/freeSupport.svg": 1876,
	"./windowsVps/global.svg": 1877,
	"./windowsVps/hq.svg": 1878,
	"./windowsVps/increase.svg": 1879,
	"./windowsVps/infrustructure.svg": 1880,
	"./windowsVps/list-vps.f735948 1.svg": 1881,
	"./windowsVps/resource.svg": 1882,
	"./windowsVps/sla.svg": 1883,
	"./windowsVps/support.svg": 1884,
	"./windowsVps/traffic-vps.aa00c67 1.svg": 1885,
	"./windowsVps/waf-d.svg": 1886,
	"./windowsVps/waf-icon-active.svg": 1887,
	"./windowsVps/waf-icon.svg": 1888,
	"./windowsVps/waf-vps.fcecd73 1.svg": 1889,
	"./windowsVps/waf.svg": 1890,
	"./xaas-gift.png": 2305,
	"./xaas-icons/Hybrid Cloud.svg": 1891,
	"./xaas-icons/Private Cloud.svg": 1892,
	"./xaas-icons/Public Cloud.svg": 1893,
	"./xaas-icons/datacenter.png": 2306,
	"./xaas-icons/security.png": 2307,
	"./xaas-icons/support.png": 2308,
	"./xaas-icons/xaas-payment.png": 2309,
	"./xaas-icons/xaas-period.png": 2310,
	"./xaas-icons/xaas-scale.png": 2311,
	"./xaas-icons/xaas-security.png": 2312,
	"./xaas-icons/xaas-support.png": 2313
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 986;